import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bs-stepper/dist/css/bs-stepper.min.css";
import Stepper from "bs-stepper";
import Details from "./Detail/Details";
import ReviewDetails from "./ReviewDetail/Review_Details";
import Header from "./Header";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { spinnerService } from "@simply007org/react-spinners";

function Booking(props) {
    const [stepper, setStepper] = useState();
    const [cuid, setCuid] = useState();
    const [isLoading, setisLoading] = useState(false);

    useEffect(() => {
        setStepper(new Stepper(document.querySelector("#stepper1")));

        // window.addEventListener("focus", onFocus)
    }, []);

    // const onFocus = (event) => {
    //     var orderId = localStorage.getItem('OrderId');
    //     if (orderId && orderId !== undefined && orderId != null) {
    //         // this.processTransactionStatus(orderId)
    //         navigate("thankyou");
    //     }
    // }

    //   processTransactionStatus(orderId) {
    //     fetch(`/pay/paytm_payment_transaction_info/`, {
    //       method: "post",
    //       headers: {
    //         "content-type": "application/json",
    //       },
    //       body: JSON.stringify({ "order": orderId, })
    //     })
    //       .then((res) => res.json())
    //       .then((res) => {
    //         console.log("Status Api :" + res)
    //         window.location = res['redirect_url'];
    //         localStorage.removeItem("OrderId")
    //         // setisLoading(false);
    //       });
    //   }

    const webLead = (value) => {
        spinnerService.show("mySpinner");
        fetch(`https://admin.care24.co.in/leadmanager/weblead`, {
            method: "post",
            body: JSON.stringify(value),
            headers: {
                "content-type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                spinnerService.hide("mySpinner");
                setCuid(res.cuid);
                stepper.next();
                // this.initialTransaction(res.cuid)
            });
    };

    const initialTransaction = () => {
        spinnerService.show("mySpinner");
        setTimeout(function () {
            fetch(`https://admin.care24.co.in/leadmanager/weblead`, {
                method: "post",
                body: JSON.stringify({
                    pay_info: { amount: 299, cuid: cuid, ptype: "DIGITRL" },
                }),
                headers: {
                    "content-type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((res) => {
                    spinnerService.hide("mySpinner");
                    if (res["orderid"] !== undefined) {
                        localStorage.setItem("OrderId", res["orderid"]);
                        // navigate('/thankyou');
                        onScriptLoad(
                            res["response"]["body"]["txnToken"],
                            "AegisC80086311709253",
                            res["orderid"]
                        );
                    }
                });
        }, 4000);
    };

    // const Payment = (txntoken, mid, orderId) => {
    //     fetch(
    //         `https://securegw.paytm.in/theia/api/v1/processTransaction?mid=${mid}&orderId=${orderId}`,
    //         {
    //             method: "POST",
    //             headers: {
    //                 "content-type": "application/json",
    //             },
    //             body: JSON.stringify({
    //                 head: {
    //                     version: "v1",
    //                     txnToken: txntoken,
    //                     channelId: "WAP",
    //                 },
    //                 body: {
    //                     mid: mid,
    //                     orderId: orderId,
    //                     requestType: "NATIVE",
    //                     paymentMode: "UPI_INTENT",
    //                     channelCode: "collect",
    //                     payerAccount: "finops@icici",
    //                 },
    //             }),
    //         }
    //     )
    //         .then((response) => response.json())
    //         .then((response) => {
    //             console.log("Response:####", response);
    //             const Link = response.body.deepLinkInfo.deepLink;
    //             const resstatus = response.body.resultInfo.resultStatus;
    //             localStorage.setItem("ConfirmOrderId", response.body.deepLinkInfo.orderId)
    //             localStorage.setItem("TransactionId", response.body.deepLinkInfo.transId)
    //             console.log("Process Transaction:######", resstatus);
    //             if (resstatus === "S") {
    //                 window.location = Link
    //             } else {
    //                 console.log("ERROR");
    //             }
    //         })
    //         .catch((err) => {
    //             console.log("error 1 :" + err);
    //         });
    // };

    function onScriptLoad(txntoken, mid, orderId) {
        var data = {
            orderId: orderId,
            token: txntoken /* update token value */,
            tokenType: "TXN_TOKEN",
            amount: 299 /* update amount */,
        };
        var config = {
            root: "",
            flow: "DEFAULT",
            merchant: {
                mid: mid,
                redirect: true, //true ..will not call backend..and have to be handled in frontend with...transactionStatus  handler
            },
            data: data,

            handler: {
                transactionStatus: function (data) {
                    console.log("payment status ", data);
                },
                notifyMerchant: function (eventName, data) {
                    console.log("eventName => ", eventName);
                    console.log("data => ", data);
                },
            },
        };
        if (window.Paytm && window.Paytm.CheckoutJS) {
            window.Paytm.CheckoutJS.init(config)
                .then(function onSuccess() {
                    window.Paytm.CheckoutJS.invoke();
                })
                .catch(function onError(error) {
                    console.log("error => ", error);
                });
        }
    }

    return (
        <>
            {/* {!isLoading && (
                <div className="centered">
                    <>
                        <FontAwesomeIcon icon="spinner" color="green" size="lg" />
                    </>
                </div>
            )} */}

            <Header></Header>

            <Card
                style={{
                    border: "none",
                    marginLeft: window.innerWidth > 700 ? "21%" : "",
                    marginRight: window.innerWidth > 700 ? "21%" : "",
                }}
            >
                <div className="m-2 mt-3">
                    {/* <Card className="offset-3 col-6 p-2" style={{ backgroundColor: "#d9edf7", color: "white" }}>“Attendant 2 Hours Trial Service” has been added to your cart.</Card> */}

                    <Card className="border-0 shadow-lg">

                        <div
                            id="stepper1"
                            className={
                                window.innerWidth > 800
                                    ? "bs-stepper "
                                    : "bs-stepper"
                            }
                        >
                            <Card.Header className="p-0 text-lg-start" >
                                <div className="row m-0" style={{background: '#eceefe'}} >
                                    <div className="step pagination  col-6 p-0" data-target="#test-l-1">
                                        <button className="step-trigger btn1 w-100" style={{
                                            borderRadius: '0px 40px 40px 0px',
                                        }}>
                                         <div className="numberCircle ps-1 me-1" style={{border:'1px solid blanchedalmond',marginBottom:'0.2rem'}}>1 </div> Your Details
                                        </button>
                                    </div>
                                    <div className="step col-6 p-0" data-target="#test-l-2" style={{ background: '#eceefe' }} >
                                        <button className="step-trigger w-100"  >
                                            <div className="numberCircle ps-1 me-1" style={{border:'1px solid blanchedalmond',marginBottom:'0.2rem',
  
}}>2 </div> Review Details & Payment
                                        </button>
                                    </div>
                                </div>
                            </Card.Header>
                            <div className="bs-stepper-content">
                                <form>
                                    <div id="test-l-1" className="content">
                                        <Details
                                            next={(value) => {
                                                webLead(value);
                                            }}
                                        ></Details>
                                    </div>
                                    <div id="test-l-2" className="content">
                                        <ReviewDetails
                                            trialNow={() => {
                                                initialTransaction();
                                            }}
                                            previous={() => {
                                                stepper.previous();
                                            }}
                                        ></ReviewDetails>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Card>
                </div>
                <Helmet>
                    <div id="paytm-checkoutjs"></div>
                    <script>
                        {`if(document.getElementById("blink_btn")){
                      document.getElementById("blink_btn").setAttribute('onclick','blink_press()')
                      }
                      if(document.getElementById("blink_btn2")){
                      document.getElementById("blink_btn2").setAttribute('onclick','blink_press()')
                      }`}
                    </script>

                    <script
                        type="application/javascript"
                        crossorigin="anonymous"
                        src="https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/AegisC80086311709253.js" //Production Server
                    ></script>
                    <script>
                        {`
                    function getUrlVars() {
                      var vars = [],
                        hash;
                      var hashes = window.location.href
                        .slice(window.location.href.indexOf("?") + 1)
                        .split("&");
                      for (var i = 0; i < hashes.length; i++) {
                        hash = hashes[i].split("=");
                        vars.push(hash[0]);
                        vars[hash[0]] = hash[1];
                      }
                      return vars;
                    }

                    function blink_press(){
                         const router_id = localStorage.getItem("router_id");
                          const careuser_id = localStorage.getItem(router_id + "cu_id");
                          var amount = document.getElementById('request_amount').value ;                        
                          var order = getUrlVars()["order"] ? parseInt(getUrlVars()["order"]) : null;
                          var ptype = getUrlVars()["ptype"] ? getUrlVars()["ptype"] : "OSD";
                          fetch("/pay/paytm_data_generator_careframe", {
                            method: "post",
                            body: JSON.stringify({
                              careuser: careuser_id,
                              order: order,
                              amount: amount,
                              ptype: ptype
                            }),
                      
                            headers: {
                              "content-type": "application/json",
                            },
                          })
                          .then(res=>res.json())
                          .then(res=>{
                            onScriptLoad(res);
                          })
                        }
                    
                    `}
                    </script>
                    <script>
                        {`
                          function onScriptLoad(obj){
                            const router_id = window.location.pathname.toString().split("/")[2];
                            var pay=localStorage.getItem(router_id+'pay')?JSON.parse(localStorage.getItem(router_id+'pay')):null;
                            
                            var data= {                  
                              "orderId"       : obj.ORDER_ID,
                              token: obj.body.txnToken /* update token value */,
                              tokenType: "TXN_TOKEN",
                              amount: obj.TXN_AMOUNT /* update amount */,
                            }
                            var config = {
                                  root: "",
                                  flow: "DEFAULT",
                                  merchant:{
                                    "mid":obj.MID,
                                    redirect: true    //true ..will not call backend..and have to be handled in frontend with...transactionStatus  handler
                                    },
                                  data: data,
                                  
                                  handler: {
                                    // transactionStatus:function(data){
                                    //   console.log("payment status ", data);
                                    //   },
                                    notifyMerchant: function (eventName, data) {
                                      // console.log("notifyMerchant handler function called");
                                      // console.log("eventName => ", eventName);
                                      console.log("data => ", data);
                                    },
                                  },
                                };
                                if(window.Paytm && window.Paytm.CheckoutJS){
                                      window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                                      window.Paytm.CheckoutJS.invoke();                                      
                                      })
                                      .catch(function onError(error){
                                        console.log("error => ",error);
                                      });                                   
                              }  
                          }   `}
                    </script>
                </Helmet>
            </Card>
        </>
    );
}
export default Booking;
